import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'store';

import { OrderPaneProps } from './orderPane.types';

const initialState: OrderPaneProps = {
  isLoading: false,
  isOpen: false,
  orderId: ''
};

const orderPaneSlice = createSlice({
  initialState,
  name: 'orderPane',
  reducers: {
    open: (state, action) => {
      state.isOpen = true;
      if (action.payload.orderId) state.orderId = action.payload.orderId;
    },
    reset: () => initialState
  }
});

export const { open, reset } = orderPaneSlice.actions;

export const selectOrderPane = (state: RootState) => state.orderPane;

export default orderPaneSlice.reducer;
